export const RETURN_TO_FULFILLMENT = {
  EG: false,
  SA: false,
  AE: true
};
